import { ToastContainer } from "react-toastify";
import AppRoute from "./components/AppRoute";
const App = () => {
  return (
    <>
      <AppRoute />;
      <ToastContainer />
    </>
  );
};

export default App;
